// extracted by mini-css-extract-plugin
export var actionButton = "_p3-0";
export var actionMenuContainer = "_p3-i";
export var bubble = "_p3-2";
export var bubbleActionMenu = "_p3-j";
export var bubbleContext = "_p3-6";
export var bubbleItems = "_p3-7";
export var customer = "_p3-3";
export var divider = "_p3-8";
export var fileList = "_p3-9";
export var hiddenComment = "_p3-o";
export var infoAbove = "_p3-a";
export var internal = "_p3-4";
export var lightActionButton = "_p3-1";
export var link = "_p3-b";
export var merchant = "_p3-5";
export var message = "_p3-c";
export var profilePicture = "_p3-e";
export var quillToolbarContainer = "_p3-f";
export var senderDate = "_p3-g";
export var senderDateCustomer = "_p3-h";
export var senderName = "_p3-d";
export var time = "_p3-k";
export var uploadedImage = "_p3-l";
export var username = "_p3-m";
export var xsmall = "_p3-n";